import * as Sentry from '@sentry/react';

import { getEventTags } from './tags';

const _sentryConfig = App.globalContext?.sentryService;

if (_sentryConfig?.enabled && _sentryConfig?.dsn) {
  Sentry.init({
    dsn: _sentryConfig.dsn,

    integrations: [
      Sentry.globalHandlersIntegration({
        onerror:              true,
        onunhandledrejection: true,
      }),
    ],

    beforeSend(event) {
      event.tags = getEventTags(event);

      // "environment" is a reserved tag in Sentry,
      // so we need to set it on the event object itself
      // for it to be recognized by Sentry's UI and filtering
      event.environment = event.tags.environment;
      return event;
    },
  });
}

window.Sentry = Sentry;

export default Sentry;
